import { Configure, Hits, useConnector } from 'react-instantsearch-hooks-web';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';
import { CustomPagination } from '../../CustomPagination';
import classNames from 'classnames';
import NrcSearchHit from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/NRCSearchHit';
import { HitProps, HIT_FIELDS, SnippetType, SnippetTypeObject } from '../../Hits/_types';
import { useSearchDictionary } from '../../util';

const attributesToHighlight: HIT_FIELDS[] = ['title', 'fileName'];

const attributesToSnippet: SnippetType[] = [{ field: 'fileName', maxWords: 40 }];

const mappedSnippets = attributesToSnippet.map((x: HIT_FIELDS | SnippetTypeObject): string => {
  const obj = x as SnippetTypeObject;
  if (obj.field && obj.maxWords) {
    return `${obj.field}:${obj.maxWords}`;
  }
  if (obj.field && obj.maxWords) {
    return obj.field;
  }
  return x as HIT_FIELDS;
});

const filter = 'reportTypeFacet:"Fees CT" OR reportTypeFacet:"Fees CO"';

export type UseStatsProps = StatsConnectorParams;

function useStats(props?: UseStatsProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats as any, props);
}

const FeeScheduleSearchHit = ({ hit }: HitProps) => {
  return <NrcSearchHit hit={hit} component="feeSchedule" />;
};

const FeeScheduleResultsWithSearch = (props: UseStatsProps) => {
  const dict = useSearchDictionary();
  const { nbHits } = useStats(props);
  const showPagination = nbHits > 10;
  return (
    <div>
      <Configure
        attributesToHighlight={attributesToHighlight}
        attributesToSnippet={mappedSnippets}
        filters={filter}
        analytics={false}
        hitsPerPage={10}
      />

      {nbHits === 0 ? (
        <div className={classNames('text-center', 'text-solidBlack', 'text-body', 'font-semibold')}>
          {dict.noResultsFound}
        </div>
      ) : (
        <>
          <div>
            <Hits hitComponent={FeeScheduleSearchHit} />
          </div>
          <div className={classNames({ hidden: !showPagination })}>
            <CustomPagination padding={1} />
          </div>
        </>
      )}
    </div>
  );
};

const FeeScheduleResults = (props: UseStatsProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    return <div>Search Results will be shown here</div>;
  }
  return <FeeScheduleResultsWithSearch {...props} />;
};

export default FeeScheduleResults;
